// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".f38270770834410afacb6cf87e86790ff4e29e3a.chunk.bundle.js";
};